import { extensionCatalog, type DigitilesExtension } from './catalog';
import { installExtension } from './install';
import { keyboardExtension } from './keyboard';
import { mouseExtension } from './mouse';
import { soundExtension } from './sound';
import { portalExtension } from './portal';
import { websocketExtension } from './websocket';
import { javascriptExtension } from './javascript';
import { storageExtension } from './storage';
import { timeExtension } from './time';
import { randomExtension } from './random';
import { binaryFileExtension } from './binaryFile';

/** Add reviewed source modules here. Loading downloaded code is intentionally not implicit. */
export const bundledExtensions: readonly DigitilesExtension[] = [
  keyboardExtension,
  mouseExtension,
  soundExtension,
  portalExtension,
  websocketExtension,
  javascriptExtension,
  storageExtension,
  timeExtension,
  randomExtension,
  binaryFileExtension,
];
let loaded = false;
export function loadBundledExtensions() {
  if (loaded) return;
  for (const extension of bundledExtensions)
    installExtension(extension, extensionCatalog, true);
  loaded = true;
}

// Registries and editor resources must share one module generation. Extension
// edits cannot be safely React-refreshed against definitions installed earlier.
if (import.meta.hot) import.meta.hot.accept(() => window.location.reload());
